import { React, useState } from "react";
import {RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { Validators } from "../../../library/utilities/Validator";
import { useGetEpbScanningEciReportMutation,useGetStatesStatusForceWiseQuery } from "../../../services/reportsServices";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";
const selectConstituencyType = [
  { value: "", label: "Select Constituency" },
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];
const tableHeader = [
  "State Name",
  "District No. and Name",
  "AC/PC No. and Name",
  "Total e-PB valid",
  "Total e-PB invalid",
  "Total e-PB manually rejected",
  "Total e-PB found duplicate",
  "Incomplete Scanned",
  "Total e-PB Scannned",

];

const EpbScanningEciReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const reportName = "e-Postal Ballot PreCounting Report"
  const SheetName = "Scanning Report"
  const [data, setData] = useState({
    constituencyType: "",
    selectState: "",
  });
  const [Error, setError] = useState({});
  const { data: getElectionAnnouncedState } = useGetStatesStatusForceWiseQuery();
  const [getReports] = useGetEpbScanningEciReportMutation()
  const stateList = [{value:"",label:"Select State"}];
  const [tableData, setTableData] = useState([]);
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "District No. and Name",
      accessor: "col2",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col3",
    },
    {
      Header: "Total e-PB Valid",
      accessor: "col4",
    },
    {
      Header: "Total e-PB Invalid",
      accessor: "col5",
    },
    {
      Header: "Total e-PB Manually Rejected",
      accessor: "col6",
    },
    {
      Header: "Total e-PB Found Duplicate",
      accessor: "col7",
    },
    {
      Header: "Incomplete Scanned",
      accessor: "col8",
    },
    {
      Header: "Total e-PB Scannned",
      accessor: "col9",
    },

  ];
  columns.map((item)=>{
    tableHeader.push(item.Header)
  })
  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  getElectionAnnouncedState?.payload?.map((item) => {
    stateList?.push({
      value: item.stateCd,
      label: item.stateName,
    });
  });

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };


  const renderTableData = () => {
    let error = {};
    if (!data.selectState || data.selectState === "" || data.selectState.length == 0) {
      error["selectState"] = "This Field is required"

    }
    if (!data.constituencyType || data.constituencyType === "" || data.constituencyType.length == 0) {
      error["constituencyType"] = "This Field is required"

    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }
      
      let payload = {
        "stateCd": data.selectState,
        "constType": data.constituencyType
      }
      getReports(payload)
        .unwrap()
        .then((res) => {
          let tData = []
          res?.payload?.map((item) => {
            tData.push({
              "col1": item.stateName,
              "col2": `${item.districtCd} ${item.districtName}`,
              "col3": `${item.acPcNo} ${item.acPcName}`,
              "col4": item.validEpbScannigCount,
              "col5": item.invalidEpbScannigCount,
              "col6": item.manuallyRejectedEpbCount,
              "col7": item.duplicateEpbScannigCount,
              "col8": item.incompleteCount,
              "col9": item.totalCount,

            });
          });
          setTableData(tData)
          setTotalNoOfRecords(res?.payload?.length)
        }).catch((error) => {
          if (error?.data?.message === "No record found") {
            setTableData([])
          }
        })
  };

  return (
  <LeftMenu>
    <div className="container box shadow ">
      <div className="row">
        <div className="col-md-12">
        <RunnerUpHeaderNew title={reportName} 
        onPdfClick={() => downloadPdfFile(reportName, tableHeader, tableData, false, true)}
        onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tableData, true)}
        />
        </div>
      </div>
      <div className="row">
        
            <SelectField
            label=""
            labelClass=""
             inputClass="col-md-4 pr-1"
              options={stateList}
              name="selectState"
              value={data?.selectState}
              handleChange={(val) => handleChange("selectState", val)}
              validators={[
                {
                  check: Validators.required,
                  message: "This field is required",
                },
              ]}
              getError={(val) => getError("selectState", val)}
              Error={Error}
            ></SelectField>
        <SelectField
            labelClass=""
            inputClass="col-md-2 pr-1"
            options={selectConstituencyType}
            value={data.constituencyType}
            name="constituencyType"
            handleChange={(val) => handleChange("constituencyType", val)}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              }
            ]}

            getError={(val) => getError("constituencyType", val)}
            Error={Error}
          ></SelectField>
        <div className="col-md-2">
          <button
            type="button"
            className="btn btn-primary btn-sm searchbuttonreport"
            onClick={renderTableData}>
            VIEW
            <span className="pl-2">
              <i class="fa fa-eye">
              </i>
            </span>
          </button>
        </div>
      </div>
      <div style={{marginTop:"-40px"}}>
        <Table
              placeholder="Search"
              globalsearch={true}
              selectall={true}
              columns={columns}
              data={tableData?.length === 0 ? [] : tableData}
              size={5}
              emptyMessage="No Record Found"
              tableClassNameCheck="contenttable-eroll"
              pagination
              records
              gotopage
              rows
              numberrows={totalNoOfRecords}
            />
        </div>
    </div>
    </LeftMenu>
  );
};

export default EpbScanningEciReport;
